import React from 'react';
import UrlLink from '../../../components/UI/UrlLink/UrlLink';
import classes from './HandlingUserData.module.css';
import paths from '../../../constants/paths';

import { QUERY_PARAM_DELETE_ACCOUNT } from '../../../containers/ContactUs/ContactUsContainer';

const es = (props) => (
  <div className={classes.Content}>
    {props.indexPage ? (
      <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}>
          <b>Descargar dato</b>
        </p>
        <p>
          Para descargar sus datos vaya a la siguiente página
          <br />
          Configuración {'>'} Opciones {'>'} Gestión de datos {'>'} Descargar
          datos
        </p>
        <br />
        <div className={classes.HrLine} />
        <br />
      </div>
    ) : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}>
      <b>Solicitar eliminación de datos</b>
    </p>
    <br />
    <p>
      Para solicitar la eliminación de datos, siga los pasos a continuación:
    </p>
    <br />
    <p>
      1. Ir a la{' '}
      <UrlLink
        to={`${
          props.indexPage ? paths.CONTACT_US : paths.SETTINGS__CONTACT_US
        }?${QUERY_PARAM_DELETE_ACCOUNT}`}
      >
        página de contacto
      </UrlLink>
      <br />
      2. Seleccione la opción "Eliminar cuenta y todos mis datos" <br />
      3. Rellena el formulario y pulsa "Enviar mensaje"
      <br />
      <br />
    </p>
  </div>
);

export default es;
